  // Run on initial page load (mfr:styles-rendered is only fired when styles are re-injected)
  jQuery( function() { initializeGSAPScripts(); } );

  function initializeGSAPScripts(e) {
      if ( typeof gsap === "undefined" ) return;
      console.log('GSAP Scripts Initialized');

      const triggers = {
          start: "top bottom", //will trigger if the top of the elements hits 75% of the viewport from top
          endTrigger: "html", // uncomment if you want to repeat class toggling
          end: "bottom top", // change to "bottom center" and comment out endTrigger if you want to repeat animation
      }
      let elements;
      
      gsap.registerPlugin( ScrollTrigger, SplitText, ScrollSmoother, Flip );

      

      //Smooth Scroll
      if( window.mfrEnableSmoothScroll && !Shopify.designMode ) {
          console.log('Smooth Scroll enabled')
          if( !ScrollTrigger.isTouch ) {
              let smoother = ScrollSmoother.create( {
                  wrapper: ".smooth-wrapper",
                  content: ".smooth-content",
                  effects: true
                  //smooth: {{ settings.gsap_smoothness | default: "0.5" }},
                  //smoothTouch: {{ gsap_smoothness_mobile | default: "0.1" }},
                  //normalizeScroll: true
              } );
                          
              window.smoother = smoother;
          }
          
          //Enter Animation
          gsap.set( $( "header.header" ), { y: 0 } );
          gsap.from( $( "header.header" ), {
                  yPercent: -100,
                  ease: "back",
                  duration: 1
              } );
      }

      //header shrink script
      const header = $( "header.header" );
      gsap.to( header, {
          scrollTrigger: {
              trigger: header,
              start: "120px top",
              endTrigger:"html",
              end:"bottom top",
              onToggle: ( args ) => {
                  header.toggleClass( "header--sticky", args.isActive );
                  header.find( ".header__wrapper" ).toggleClass( "header__wrapper--sticky", args.isActive );
                  header.find( ".header__logo img:first-child" ).toggleClass( "is-active", !args.isActive );
                  header.find( ".header__logo img:last-child" ).toggleClass( "is-active", args.isActive );
              }
          }
      } );

      // Image Parallax
      gsap.utils.toArray("[data-image-parallax]").forEach((section, i) => {
          const heightDiff = $( section ).find( "> img, > picture" ).outerHeight() - $( section ).outerHeight();
      
          gsap.fromTo($( section ).find( "> img, > picture" ),{ 
              y: -heightDiff
          }, {
          scrollTrigger: {
              trigger: section,
              scrub: true
          },
              y: 0,
              ease: "none"
          });
      });

      //is-inview elements
      ScrollTrigger.batch( "[data-inview]", {
          ...triggers,
          onEnter: (batch) => {
              batch.forEach( element => $( element ).addClass( "is-inview" ) );
          },
          onLeaveBack: ( batch ) => {
              batch.forEach( element => $( element ).removeClass( "is-inview" ) );
          }
      })

      // is-inview elements with stagger
      // usage: data-stagger-inview=".inner-element-class"
      ScrollTrigger.batch( "[data-stagger-inview]", {
          ...triggers,
          onEnter: (batch) => {
              batch.forEach( element => {
                  const children = $( element ).find( $( element ).data( "stagger-inview" ) );
                  gsap.to(children, {
                      stagger: {
                          each: 0.1,
                          onComplete() {
                            $( this.targets()[0] ).addClass( "is-inview" );
                          }
                      },
                  })
              } );
          },
          onLeaveBack: ( batch ) => {
              batch.forEach( element => {
                  const children = $( element ).find( $( element ).data( "stagger-inview" ) );
                  children.removeClass( "is-inview" )
              } );
          }
      } );

      //Split Text Animation
      $( "[data-split-text]" ).each( (i, element) => {
          $( element ).addClass( "split-text--rendered" );
          const splitTexts = new SplitText( element, { type: "words", wordsClass: "split-text" } );
          const chars = gsap.utils.toArray( splitTexts.words );
          gsap.set( element, { overflow: "hidden" } );
          
          $(chars).each((i, e) => {
              $(e).wrapInner("<span class='split-text__inner'></span>");
          });
          ScrollTrigger.create( {
              trigger: $( element ),
              ...triggers,
              onEnter: (batch) => {
                  gsap.to(chars, {
                      stagger: {
                          delay: 0,
                          each: 0.1,
                          onComplete() {
                              $( this.targets()[0] ).addClass( "is-inview" );
                          }
                      },
                      immediateRender: true
                  })
              },
              onLeaveBack: (batch) => {
                  chars.forEach((element, index) => $(element).removeClass("is-inview"));
              }
          } );
      } );

      

      $( "[data-shine='2']" ).each( ( i, element ) => {
          //shine animation
          const shineTL = gsap.timeline({
              repeat: -1,
              yoyo: true
          });
          shineTL
              .to( $( element ).find( ".shine-1-1" ), {
                  duration: 1,
                  morphSVG: $( element ).find( ".shine-2-1" )
              } )
              .from( $( element ).find( ".shine-1-2" ), {
                  duration: 1,
                  morphSVG: $( element ).find( ".shine-2-2" )
              }, "<.5" );
      } );

      //For Sticky Elements
      setTimeout( () => {
          $("[data-mfr-sticky-container]").each((i, element) => {
              const child = $(element).find("[data-mfr-sticky]");
              
              if (child.length) {
                  const scrollTrigger = ScrollTrigger.create({
                      trigger: child,
                      start: `center center+=${$("header.header").outerHeight() / 2}px`,
                      end: `+=${$(element).height() - child.innerHeight()}px`,
                      pin: true,
                      pinSpacing: false
                  });
              }
          });
      }, 400 );


      $( "section" ).each( ( i, element ) => {
          if( i % 1 == 0 ) $( element ).find( ".custom-underline" ).css( "--rotate-deg", "0deg" );
          if( i % 2 == 0 ) $( element ).find( ".custom-underline" ).css( "--rotate-deg", "0deg" );
      } );


      $( "[data-mfr-bubbles]" ).each( (i, e) => {
          const wrapper = $( e );
          const bubbles = wrapper.find( "[data-mfr-bubble]" );
          const yPercentages = [-50,-200,-50,-100];
          bubbles.each( (index, bubble) => {
              gsap.to(bubble, {
                  yPercent: yPercentages[index],
                  ease: "none",
                  scrollTrigger: {
                      trigger: wrapper,
                      // start: "top bottom", // the default values
                      // end: "bottom top",
                      scrub: true
                  }, 
              });
          } );
      } );

      $( "[data-accent-graphic-parallax-speed]" ).each( (i,e) => {
          gsap.fromTo(e, {
              yPercent: `${$( e ).data( "accent-graphic-parallax-speed" ) * 50}`,
              ease: "none"
          },{
              yPercent: `-${$( e ).data( "accent-graphic-parallax-speed" ) * 50}`,
              ease: "none",
              scrollTrigger: {
                  trigger: $( e ),
                  scrub: true
              }
          });
      } );
      $( "[data-mfr-animated-text]" ).each( (i, e) => {
          const wrapper = $( e );
          const trigger_wrapper = wrapper.find(".text-animation-out");
          const headline_stagger = wrapper.find(".split-text__inner");
          const body_text = wrapper.find(".js-text-animation-2");
          const circle_1 = wrapper.find(".animated-circle");
          const circle_2 = wrapper.find(".animated-circle-2");
          const letters_offset = 100
          const toggle_string = "play none none reverse"
         
          
          gsap.set(body_text, {opacity: 0, y: 0});  
          gsap.set(headline_stagger, {y: letters_offset});
          //gsap.set(circle_1, { y: 500});
          gsap.set(circle_2, {opacity: 0});
          gsap.fromTo(headline_stagger,    
              {
                  y: letters_offset, 
                  opacity: 0,
                  stagger: 0.1,
                  duration: 0.2,
                  ease: "power3.in"                    
              },
              {
                  scrollTrigger: {
                      trigger: trigger_wrapper,
                      start: "top 50%",
                      // markers: true,
                      toggleActions: 'play none none reverse',
                      onEnterBack: () => {
                          console.log('PPPP')   
                      }
                  },    
                  y: 0, 
                  opacity: 1,
                  stagger: 0.1,
                  duration: 0.2,
                  ease: "power3.in"
              }
          )

          gsap.fromTo(circle_1,
              {scale:1, opacity: 1, y: 0},
              {
                  scrollTrigger: {
                      trigger: trigger_wrapper,
                      start: "20% top",
                      // markers: true,                        
                      toggleActions: "play none none reverse"
                  },
                  y: 0,
                  scale: 20,
                  duration: 1,
                  ease: "power3.in"
              }
          )
          gsap.fromTo(circle_1,
              {scale:1, opacity: 1, y: 500},
              {
                  scrollTrigger: {
                      trigger: trigger_wrapper,
                      start: "top 10%",
                      // markers: true,                        
                      toggleActions: "play none none reverse"
                  },
                  y: 0,
                  scale: 1,
                  duration: 1
              }
          )
             
          // gsap.to(circle_1,
          //     {
          //         scrollTrigger: {
          //             trigger: trigger_wrapper,
          //             start: "top 10%",
          //             markers: true,                        
          //             toggleActions: "play none none reverse"
          //         },
          //         y: 0,
          //         scale: 2.5,
          //         duration: 1
          //     }
          // )            
          // gsap.to(circle_1,
          //     {
          //         scrollTrigger: {
          //             trigger: trigger_wrapper,
          //             start: "20% top",
          //             // markers: true,                        
          //             toggleActions: "play none none reverse"
          //         },
          //         y: 0,
          //         scale: 20,
          //         duration: 1,
          //         ease: "power3.in"
          //     }
          // )
          gsap.to(headline_stagger,
              {
              scrollTrigger: {
                  trigger: trigger_wrapper,
                  start: "20% top",
                  // markers: true,
                  toggleActions: 'play none none reverse',
             
              },
              duration: 0.2,
              y: -letters_offset,
              stagger: 0.1,
              }
          )
          gsap.to(body_text,
              {
              scrollTrigger: {
                  trigger: trigger_wrapper,
                  start: "60% 45%",
                  // markers: true,
                  toggleActions: "play none none reverse"    
              },
              y: 0, opacity: 1, duration: 1.5,
              }
          )            

          gsap.to(circle_2,
              {
              scrollTrigger: {
                  trigger: trigger_wrapper,
                  start: "60% 50%",
                  toggleActions: toggle_string,
                  // markers: true,                        
              },
              opacity: 0.6, y: 0, scale: 6, duration: 1.5 
              }
          )
      });
      
      ScrollTrigger.batch( $( "[data-animated-number]" ), {
          ...triggers,
          onEnter: batch => {
              $.each( batch, ( i, e ) => {
                const element = $( e );
                const finalNumber = element.text();
                console.log( finalNumber );
                $({numberValue: 0}).animate({numberValue: finalNumber}, {
                  duration: 1100,
                  easing: 'linear',
                  progress: function() {
                      $(e).text(this.numberValue.toFixed(element.data( "animated-number" ) ) );
                  }
                });
              } );
          }
      } );

      const productTopATC = $( ".template-product .product-top .product-top__submit" );
      if( productTopATC.length ) {
        ScrollTrigger.create({
          trigger: productTopATC,
          start: "top 25%",
          endTrigger: "html",
          end: "bottom top",
          onToggle: (self) => {
            const stickyATC = $( ".sticky-atc" );
            if( !stickyATC.length ) return;

            stickyATC.toggleClass( "is-hidden", !self.isActive );
          }
        })
      }
  }